import { Modal } from 'antd';
import { FiAlertTriangle, FiInfo, FiTrash2, FiX } from 'react-icons/fi';

const toneIcons = {
  danger: FiTrash2,
  warning: FiAlertTriangle,
  info: FiInfo,
};

export const confirmAction = ({
  title,
  content,
  okText,
  cancelText,
  danger = false,
  tone,
  onOk,
  onCancel,
}) => {
  const resolvedTone = tone || (danger ? 'danger' : 'info');
  const ToneIcon = toneIcons[resolvedTone] || FiInfo;

  return Modal.confirm({
    className: `app-confirm-dialog app-confirm-dialog--${resolvedTone}`,
    rootClassName: 'app-confirm-root',
    width: 460,
    icon: (
      <span className='app-confirm-icon' aria-hidden='true'>
        <ToneIcon />
      </span>
    ),
    title: <span className='app-confirm-title'>{title}</span>,
    content: <div className='app-confirm-description'>{content}</div>,
    okText,
    cancelText,
    okButtonProps: {
      danger: resolvedTone === 'danger',
      className: 'app-confirm-button app-confirm-button--primary',
    },
    cancelButtonProps: {
      className: 'app-confirm-button app-confirm-button--secondary',
    },
    centered: true,
    closable: true,
    closeIcon: <FiX aria-label={cancelText} />,
    keyboard: true,
    maskClosable: false,
    autoFocusButton: resolvedTone === 'danger' ? 'cancel' : 'ok',
    onOk,
    onCancel,
  });
};
